"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PortalBase = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _reactJss = require("react-jss");
var _ThemeProvider = _interopRequireDefault(require("../ThemeProvider"));
var _environmentCharacteristics = require("../utils/environmentCharacteristics");
var _omit = _interopRequireDefault(require("../utils/omit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var PortalBase = exports.PortalBase = function PortalBase(_ref) {
  var container = _ref.container,
    children = _ref.children;
  var theme = (0, _reactJss.useTheme)();
  if (!_environmentCharacteristics.isBrowser) {
    return null;
  }
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react.default.createElement(_ThemeProvider.default, _extends({}, (0, _omit.default)(["withGlobalStyles"], theme.themeProviderProps), {
    nested: true
  }), children), container);
};
var _default = exports.default = PortalBase;